import {SprintsRepository} from '../persistence/sprints_repository';
import {SprintApi} from '../network/sprint_api';
import {AvailabilitiesRepository} from '../persistence/availabilities_repository';

interface Page {
    offset: number;
    numberOfWeeks: number;
}

export class GridLoader {
    private currentPage: Page;

    constructor(
        private initialPage: Page,
        private sprintApi: SprintApi,
        private sprintsRepository: SprintsRepository,
        private availabilitiesRepository: AvailabilitiesRepository,
    ) {
        this.currentPage = initialPage;
    }

    public async fetch(offset: number, numberOfWeeks: number): Promise<void> {
        this.currentPage = {
            offset,
            numberOfWeeks,
        };
        const data = await this.sprintApi.grid(offset, numberOfWeeks);

        this.sprintsRepository.storeMany(data.sprints);
        this.availabilitiesRepository.storeMany(data.availabilities);
    }

    public async invalidate() {
        const data = await this.sprintApi.grid(this.currentPage.offset, this.currentPage.numberOfWeeks);

        this.sprintsRepository.replace(data.sprints);
        this.availabilitiesRepository.replace(data.availabilities);
    }
}
